/** Supabase product photos are already optimized WebP; local uploads need Next's responsive variants. */
export function shouldSkipProductImageOptimization(src: string): boolean {
  try {
    const url = new URL(src);
    return (url.protocol === "https:"
      && url.hostname.endsWith(".supabase.co")
      && url.pathname.startsWith("/storage/v1/object/public/product-images/"));
  } catch {
    return false;
  }
}
